export default "__VITE_PUBLIC_ASSET__8cddd970__"